import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { requestCanceller } from '../../service/axiosCancelToken';
import kojaImage from './image/koja.png';
import './Where.css';
import { getAllPlaceCategories } from './../../service/placeCategoryService';
import LoadingSpinner from '../shared/LoadingSpinner';
import { Helmet } from 'react-helmet';
import socket from '../../service/socket';
import { getCookie, getUid } from '../../service/authCookie';
import { checkVisit } from '../../service/checkVisit';

const Where = () => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);
    const [placeCategories, setPlaceCategories] = useState();
    const [searchInput, setSearchInput] = useState('');
    const placeCategoriesRef = useRef(null);
    useEffect(() => {
        const cancelRequest = requestCanceller();

        const fetchAllCategories = async () => {
            try {
                setIsLoading(true);
                let { status, data } = await getAllPlaceCategories({cancelToken: cancelRequest.signal});
                if(status === 201){
                    data.placeCategories.unshift({_id: 'all', title: '*** همه ***'});
                    placeCategoriesRef.current = data.placeCategories;
                    setPlaceCategories(data.placeCategories);
                }
                
                setIsLoading(false);
            } catch (err) {

            }
        }
        fetchAllCategories();
        return () => {
			cancelRequest.cancel();
        }
    }, []);
    const searchInputHandler = (event) => {
        try {
            setSearchInput(event.target.value);
            const searchText = new RegExp(event.target.value,'i');
            let searchedItems = [];
            placeCategoriesRef.current.forEach(category => {
                if(searchText.test(category.title))
                searchedItems.push(category);
            });
            setPlaceCategories(searchedItems);
        } catch (error) {}
    }
    useEffect(()=> {
        socket.emit("viewMessage", {
            location: window.location.href,
            authenticated: getCookie(),
            UID : getCookie() ? getUid() : null
        }, (response) => {
            if(response && response.status === 'New')
            checkVisit(response.uId)
        });
    },[]);
    return ( 
        <div className="where-layer">
            <div className="container">
                <Helmet>
                    <title>3 دان | کجا خوبه ؟ ، فروشگاه ، اموزشگاه ، باشگاه ، مکان های تفریحی ، مرکز خرید ، بهترین مکان ها </title>
                </Helmet>
                <header className="d-flex flex-wrap justify-content-between align-items-between">
                    <div className="col-12 col-sm-4 px-0">
                        <img src={kojaImage} alt="" className="main-image-top mr-1"/>
                        <small className="font-weight-bold">کجا خوبه ؟ ( مکان ها )</small>
                    </div>
                    <div className=" col-6 col-sm-4 px-0 mt-2 ">
                        <h6 className="font-weight-bold">
                            انتخاب کنید ...
                        </h6>
                    </div>
                    <div>
                    <div className="d-flex mx-md-0 search-ki-category mt-2 ">
                        <span className="">
                            <i className="fa fa-search"></i>
                        </span>
                        <input
                            type="text"
                            placeholder="جستجو کنید"
                            className="col inline-block form-control"
                            value={searchInput}
                            onChange={searchInputHandler}
                        />
                    </div>
                    </div>
                </header>  
                <section>
                    {
                        (isLoading || !placeCategories) ? 
                        <div style={{ height: '70vh' }} className="d-flex">
                            <div className="text-center align-self-center mx-auto">
                                <LoadingSpinner />
                            </div>
                        </div>
                        :
                        <div className="featured px-lg-5">
                            <div className="row mt-5 px-xl-5">
                                {
                                    placeCategories.map(item => 
                                        <div 
                                            className="col-12 col-sm-6 col-md-4"
                                            key={item._id}
                                        >
                                            <div className="featured-item my-2 d-flex p-1 text-capitalize
                                                align-items-baseline flex-wrap justify-content-center"
                                                onClick={() => history.push('/where/places',
                                                { category: item}
                                                )}
                                                >
                                                <h6 className="font-weight-bold mx-1 text-dark">{item.title}</h6>
                                                <span className="featured-icon ml-auto">
                                                    <i className="fa fa-sign-in "></i>
                                                </span>
                                            </div>    
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    }
                </section>  
            </div>
        </div>
     );
}
 
export default Where;